<div class="page-header">
  <div class="user-options">
    <button
      tuiButton
      appearance="primary-button"
      size="m"
      icon="tuiIconPlusCircleLarge"
      (click)="openModalAddService()"
    >
      {{ "pool_manager.menu.new_service" | translate }}
    </button>
  </div>
</div>

<!-- Contenedor principal -->
<div class="table-container">
  <div class="table-body">
    <nav class="navbar" role="tablist">
      <ul class="nav-list">
        <li class="nav-item">
          <button
            type="button"
            class="nav-link"
            role="tab"
            id="tab-pool-management"
            [class.active]="activeLink === 'pool-management'"
            [attr.aria-selected]="activeLink === 'pool-management'"
            [attr.aria-controls]="'panel-pool-management'"
            (click)="setActiveLink('pool-management')"
          >
            <span class="nav-text">
              {{ "pool_manager.menu.services_not_started" | translate }}
            </span>

            <tui-tag
              class="tag"
              status="custom"
              [hoverable]="true"
              [value]="freelancePoolServicesNotStartedCount.toLocaleString()"
            ></tui-tag>
          </button>
        </li>

        <li class="nav-item">
          <button
            type="button"
            class="nav-link"
            role="tab"
            id="tab-historical"
            [class.active]="activeLink === 'historical'"
            [attr.aria-selected]="activeLink === 'historical'"
            [attr.aria-controls]="'panel-historical'"
            (click)="setActiveLink('historical')"
          >
            <span class="nav-text">
              {{ "pool_manager.menu.historical" | translate }}
            </span>

            <tui-tag
              class="tag"
              status="custom"
              [hoverable]="true"
              [value]="freelancePoolServicesCount.toLocaleString()"
            ></tui-tag>
          </button>
        </li>
      </ul>
    </nav>

    <div class="tab-panels" [ngSwitch]="activeLink">
      <section
        role="tabpanel"
        id="panel-pool-management"
        [attr.aria-labelledby]="'tab-pool-management'"
        *ngSwitchCase="'pool-management'"
      >
        <app-services-not-started-table
          [data]="pendingServices"
          [isLoading]="isLoadingPending"
          (countEvent)="getCountServicesNotStarted($event)"
          (refreshRequested)="refreshPendingServices()"
        ></app-services-not-started-table>
      </section>

      <section
        role="tabpanel"
        id="panel-historical"
        [attr.aria-labelledby]="'tab-historical'"
        *ngSwitchCase="'historical'"
      >
        <app-historical-table
          [data]="historicalServices"
          [isLoading]="isLoadingHistorical"
          [useApiFiltering]="true"
          [totalItems]="historicalTotalItems"
          [currentPage]="historicalPageIndex"
          [serverPageSize]="historicalPageSize"
          (countEvent)="getCountServicesNotStarted($event)"
          (filtersChange)="onHistoricalFiltersChange($event)"
        ></app-historical-table>
      </section>
    </div>
  </div>
</div>
